import { render, staticRenderFns } from "./PMChartVersionCreation.vue?vue&type=template&id=ebe09730&"
import script from "./PMChartVersionCreation.vue?vue&type=script&lang=ts&"
export * from "./PMChartVersionCreation.vue?vue&type=script&lang=ts&"
import style0 from "./PMChartVersionCreation.vue?vue&type=style&index=0&id=ebe09730&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports